import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface LocationState {
  email?: string;
}

const VerifyEmailSent: React.FC = () => {
  const location = useLocation();
  const { user, resendVerification } = useAuth();
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  const stateEmail = (location.state as LocationState | null)?.email;
  const email = stateEmail || user?.email;

  const onResend = async () => {
    setStatus('sending');
    try {
      const msg = await resendVerification();
      setMessage(msg);
      setStatus('sent');
    } catch (err: any) {
      setMessage(
        err?.response?.data?.detail?.message ||
          err?.response?.data?.detail ||
          'Could not resend right now. Please try again in a minute.'
      );
      setStatus('error');
    }
  };

  return (
    <div className="app-layout min-h-screen flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full text-center">
        <div className="app-brand" style={{ fontSize: '32px', marginBottom: '16px' }}>
          babylon.markets
        </div>
        <div className="app-card" style={{ padding: '24px' }}>
          <h2 style={{ color: '#ffffff', fontSize: '20px', marginBottom: '12px' }}>
            Check your email
          </h2>
          <p style={{ color: '#cccccc', fontSize: '14px', lineHeight: 1.6 }}>
            We sent a verification link to{' '}
            {email ? (
              <strong style={{ color: '#ffffff' }}>{email}</strong>
            ) : (
              'your inbox'
            )}
            . Click it to activate your account.
          </p>
          <p style={{ color: '#888888', fontSize: '13px', marginTop: '12px' }}>
            You can keep using babylon.markets in the meantime — some features will unlock
            once your email is verified.
          </p>

          <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Link
              to="/dive-in"
              className="btn-primary"
              style={{ width: '100%', textAlign: 'center', textDecoration: 'none' }}
            >
              Go to dashboard
            </Link>
            <button
              type="button"
              onClick={onResend}
              disabled={status === 'sending' || !user}
              style={{
                background: 'transparent',
                border: '1px solid #4a4a4a',
                color: user ? '#cccccc' : '#666666',
                padding: '10px 12px',
                borderRadius: '4px',
                cursor: user && status !== 'sending' ? 'pointer' : 'not-allowed',
                fontSize: '13px',
              }}
            >
              {status === 'sending' ? 'Sending...' : 'Resend verification email'}
            </button>
          </div>

          {message && (
            <p
              role="status"
              aria-live="polite"
              style={{
                marginTop: '14px',
                fontSize: '13px',
                color: status === 'error' ? '#f44336' : '#22c55e',
              }}
            >
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailSent;
